import React from "react";
import {
  AuthorBoxWrapper,
  AuthorWrapper,
  AuthorImageWrapper,
  SocialMediaWrapper,
  TextWrapper,
} from "./styles.Author";

import twitterIcon from "../../assets/science-in-context_twitter.svg";
import linkedinIcon from "../../assets/science-in-context_linkedin.svg";

interface PropsSM {
  link: string;
  icon: string;
}

export const SocialMedia: React.FC<PropsSM> = ({ link, icon }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {" "}
      <img src={icon} alt="Social Media Icon" />
    </a>
  );
};

interface PropsAuthorImage {
  src: string;
}

export const AuthorImage: React.FC<PropsAuthorImage> = ({ src }) => {
  return <AuthorImageWrapper src={src}></AuthorImageWrapper>;
};

interface Props {
  authorImage: string;
  name: string;
  twitter?: string;
  linkedin?: string;
}

export const Author: React.FC<Props> = ({
  authorImage,
  name,
  twitter,
  linkedin,
  children,
}) => {
  function generateTwitter() {
    if (twitter) {
      return <SocialMedia link={twitter} icon={twitterIcon}></SocialMedia>;
    }
  }

  function generateLinkedin() {
    if (linkedin) {
      return <SocialMedia link={linkedin} icon={linkedinIcon}></SocialMedia>;
    }
  }

  return (
    <AuthorWrapper>
      <AuthorImage src={authorImage} />

      <TextWrapper>
        <strong>{name}</strong>
        {children}
        <SocialMediaWrapper>
          {generateTwitter()}
          {generateLinkedin()}
        </SocialMediaWrapper>
      </TextWrapper>
    </AuthorWrapper>
  );
};

export const AuthorBox: React.FC = ({ children }) => {
  return <AuthorBoxWrapper>{children}</AuthorBoxWrapper>;
};
